import React, { useEffect, useState } from "react";
import {
  AboutText,
  ButtonImg,
  CenterAbout,
  Container,
  DivButton,
  HeaderAbout,
  InstructionDiv,
  OuterDiv,
} from "./InstructionStyle";
import { images as imageValues } from "../../imageValues";
import Button from "../../component/Button/Button";
import stringValues from "../../stringValues";
import { connect } from "react-redux";

const Instruction = ({
  changeLanguageState,
  onClick,
  playPauseSoundState,
  changeLanguage,
  playPauseSound,
  onClickShare,
}) => {
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Container>
        {mobileWidth < 1080 && (
          <OuterDiv>
            <DivButton onClick={changeLanguage} title="Language">
              <ButtonImg src={imageValues.LANGUAGE} />
            </DivButton>
            <DivButton onClick={playPauseSound} title="Sound">
              {playPauseSoundState.data ? (
                <ButtonImg src={imageValues.VOLUMEON} />
              ) : (
                <ButtonImg src={imageValues.VOLUMEOOF} />
              )}
            </DivButton>
            <DivButton onClick={onClickShare} title="Share">
              <ButtonImg src={imageValues.SHAREBUTTON} />
            </DivButton>
          </OuterDiv>
        )}
        <CenterAbout>
          <HeaderAbout>
            {" "}
            {stringValues[changeLanguageState.data].instructions}{" "}
          </HeaderAbout>
          <InstructionDiv>
            <AboutText>{stringValues[changeLanguageState.data].goal}</AboutText>
            <img
              src={imageValues.FULL_COLLECTION_ROOM}
              style={{
                height: 80,
                width: "auto",
              }}
            />
          </InstructionDiv>
          <InstructionDiv>
            <img
              src={imageValues.ROLLSIX}
              style={{
                height: 70,
                width: "auto",
              }}
            />
            <AboutText>
              {stringValues[changeLanguageState.data].shakeAndRole}
            </AboutText>
          </InstructionDiv>
          <InstructionDiv>
            <AboutText>
              {stringValues[changeLanguageState.data].growCollection}
            </AboutText>
            <img
              src={imageValues.MARKETTHREENEW}
              style={{
                height: 100,
                width: "auto",
              }}
            />
          </InstructionDiv>
          <InstructionDiv>
            <img
              src={imageValues.OLDCAR}
              style={{
                height: 110,
                width: "auto",
              }}
            />
            <AboutText>
              {stringValues[changeLanguageState.data].transport}
            </AboutText>
          </InstructionDiv>
        </CenterAbout>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Button
            label={stringValues[changeLanguageState.data].journeyButton}
            onClick={onClick}
            style={{ fontWeight: 600 }}
          />
        </div>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  changeLanguageState: state.changeLanguage,
  playPauseSoundState: state.playPauseSound,
});

export default connect(mapStateToProps)(Instruction);
